export default __webpack_public_path__ + "static/media/logo-IT-mobile.5ba81dfe.svg";